import { Controller } from "@hotwired/stimulus"

// Fills the Stundenlohn field with the tariff entitlement of the employee's Lohngruppe.
//
// A suggestion only: what gets saved is an ordinary wage entry that does not follow later
// tariff steps, because whether a step is passed on depends on the individual contract.
export default class extends Controller {
  static targets = ["field"]
  static values = { amount: Number }

  apply(event) {
    event.preventDefault()

    const field = this.fieldTarget
    field.value = this.amountValue.toFixed(2)
    field.dispatchEvent(new Event("input", { bubbles: true }))
    field.focus()
  }
}
